import dynamic from 'next/dynamic'
import { FacebookPixelProps } from './FacebookPixel'

export const FacebookPixelClientOnly = dynamic<FacebookPixelProps>(
	() => import('./FacebookPixel').then((mod) => mod.FacebookPixel),
	{
		ssr: false,
	},
)
